export default __webpack_public_path__ + "static/cursor_default_2-fc2d79e33ee29ac71c7d4afd6983f7f6.png";